

export class ProjectPnLDto implements IProjectPnLDto {
    projectId!: number;
    projectName!: string | undefined;
    isOverhead!: boolean;
    totalReceived!: number;
    totalCost!: number;
    readonly net!: number;

    constructor(data?: IProjectPnLDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.isOverhead = _data["isOverhead"];
            this.totalReceived = _data["totalReceived"];
            this.totalCost = _data["totalCost"];
            (<any>this).net = _data["net"];
        }
    }

    static fromJS(data: any): ProjectPnLDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectPnLDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["isOverhead"] = this.isOverhead;
        data["totalReceived"] = this.totalReceived;
        data["totalCost"] = this.totalCost;
        data["net"] = this.net;
        return data; 
    }
}

export interface IProjectPnLDto {
    projectId: number;
    projectName: string | undefined;
    isOverhead: boolean;
    totalReceived: number;
    totalCost: number;
    net: number;
}

